export const enum RouteLabels {
    PROJECT_MAIN_NAVIGATION = 'aumico_reports_main_navigation_projects',
    PROJECT_LIST = 'aumico_reports_main_navigation_projects',
    FINANCIAL_STATEMENT_GENRAL_INFORMATION = 'aumico_reports_annualreport_navigation_generalinformation',
    FINANCIAL_STATEMENT_IMPORT = 'aumico_reports_annualreport_navigation_import',
    FINANCIAL_STATEMENT_CLOSING_PROCESS = 'aumico_reports_annualreport_navigation_fcp',
    FINANCIAL_STATEMENT_UPLOAD = 'aumico_reports_annualreport_navigation_import_upload',
    FINANCIAL_STATEMENT_MAPPING = 'aumico_reports_annualreport_navigation_import_mapping',
    FINANCIAL_STATEMENT_GROUPING_MASKING = 'aumico_reports_annualreport_navigation_import_grouping_masking',
    FINANCIAL_STATEMENT_FX = 'aumico_reports_annualreport_navigation_import_fx',
    FINANCIAL_STATEMENT_CASH_FLOW = 'aumico_reports_annualreport_navigation_cfs',
    FINANCIAL_STATEMENT_NOTES_STEP = 'aumico_reports_annualreport_navigation_notes',
    FINANCIAL_STATEMENT_AOP = 'aumico_reports_annualreport_navigation_aop',
    FINANCIAL_STATEMENT_EQUITY_MOVEMENT_SCHEDULE = 'aumico_reports_annualreport_navigation_equity_movement_schedule',
    FINANCIAL_STATEMENT_FIXED_ASSETS_SCHEDULE = 'aumico_reports_annualreport_navigation_fixed_assets_schedule',
    FINANCIAL_STATEMENT_ADJUSTMENTS_AND_RECLASSES = 'aumico_reports_annualreport_navigation_adjustments_and_reclasses',
    FINANCIAL_STATEMENT_COMPLEMENTARY_REPORTS = 'aumico_reports_annualreport_navigation_complementary_reports',
    FINANCIAL_STATEMENT_FINISH_AND_PRINT = 'aumico_reports_annualreport_navigation_finish_and_print',

    //TASKS
    TASKS = 'aumico_reports_main_navigation_tasks',
    CLOSING_AND_TASKS = 'aumico_reports_main_navigation_tasks_and_closing',

    // COMPANIES
    COMPANIES_MAIN_NAVIGATION = 'aumico_reports_main_navigation_company_list',
    COMPANIES_LIST = 'aumico_reports_main_navigation_company_list',
    COMPANY_PROFILE = 'aumico_reports_main_navigation_company_profile',
    COMPANY_INTEGRATIONS = 'aumico_reports_main_navigation_company_integrations',
    COMPANY_ANALYTICS = 'aumico_reports_main_navigation_company_analytics',
    // REV-22155: PERSONS
    PERSONS_MAIN_NAVIGATION = 'aumico_reports_main_navigation_person_list',
    PERSON_NEW = 'aumico_reports_main_navigation_person_new',
    PERSON_PROFILE = 'aumico_reports_main_navigation_person_profile',
    //COMPANY_VALUATION
    COMPANY_VALUATION = 'aumico_reports_main_navigation_company_valuation',
    VALUATION_REPORT = 'aumico_reports_company_valuation_navigation_valuation_report',
    // CLOSING_PROCESS_ENABLING
    CLOSING_PROCESS_ENABLING = 'aumico_reports_main_navigation_closing_process_enabling',
    // ORGANIZATION
    ORGANIZATION = 'aumico_reports_main_navigation_organization',
    ORGANIZATION_SETTINGS = 'aumico_reports_main_navigation_organization_settings',
    ORGANIZATION_PROFILE = 'aumico_reports_organization_settings_navigation_organization_profile',
    ORGANIZATION_SUBSCRIPTION = 'aumico_reports_organization_settings_navigation_organization_subscription',
    TEXT_SNIPPETS = 'aumico_reports_organization_settings_navigation_text_snippets',
    CHECKLISTS = 'aumico_reports_organization_settings_navigation_checklists',
    WORKFLOW = 'aumico_reports_organization_settings_workflow',
    MANDATE_MANAGEMENT = 'aumico_reports_organization_settings_mandate_management',
    CLOSING_WORKFLOW = 'aumico_reports_organization_settings_closing_workflow',
    SETTINGS = 'aumico_reports_main_navigation_organization_settings',
    DESIGN_SETTINGS = 'aumico_reports_main_navigation_design_settings',
    ORGANIZATION_USERS = 'aumico_reports_organization_navigation_users',
    TWO_FACTOR_AUTHENTICATION = 'aumico_reports_organization_navigation_2fa',
    AI_SETTINGS = 'aumico_reports_organization_settings_navigation_ai_settings',
    INTEGRATIONS = 'aumico_reports_organization_settings_navigation_integrations',
    //CPMM
    REPORT_CLOSING_WORKFLOW = 'aumico_reports_annual_report_navigation_closing_workflow',
    // ABCP
    REPORT_CLOSING = 'aumico_reports_annual_report_navigation_closing',
    REPORT_MANDATE_MANAGEMENT = 'aumico_reports_annual_report_navigation_mandate_management',
    REPORT = 'aumico_reports_annual_report_navigation_report',
    // USER
    USER_ACCOUNT = 'aumico_reports_main_navigation_user_profile',
    USER_GENERAL_INFORMATION = 'aumico_reports_profile_navigation_generalinformation',
    USER_SECURITY = 'aumico_reports_profile_navigation_security',
    // HELP
    HELP = 'aumico_reports_side_bar_help',
    DESIGN = 'DESIGN',
}
